import {
  Box,
  Heading,
  Text,
  Stack,
  Bleed,
  Actions,
  ButtonLink,
  Spread,
} from 'braid-design-system';

interface ArticleCardProps {
  title: string;
  subtitle: string;
  link: string;
  image: string;
}

export function ArticleCard({
  title,
  subtitle,
  link,
  image,
}: ArticleCardProps) {
  return (
    <Box
      padding="medium"
      background="surface"
      borderRadius="large"
      boxShadow="large"
      height="full"
    >
      <Spread space="large" direction="vertical">
        <Stack space="large">
          <Bleed horizontal="medium" top="medium">
            <Box
              overflow="hidden"
              style={{
                borderTopLeftRadius: 14,
                borderTopRightRadius: 14,
                maxHeight: 150,
              }}
            >
              <img src={image} alt={title} />
            </Box>
          </Bleed>
          <Stack space="medium">
            <Heading level="4">{title}</Heading>
            <Text tone="secondary">{subtitle}</Text>
          </Stack>
        </Stack>
        <Actions>
          <ButtonLink href={link} target="_blank" variant="solid">
            Read the article
          </ButtonLink>
        </Actions>
      </Spread>
    </Box>
  );
}
